import PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ErrorListProps {
  errors?: Array<string> | null;
  errorMessage?: string | null;
}

const ErrorList = ({errors, errorMessage}: ErrorListProps): JSX.Element | null => {
  if (!errors && !errorMessage) {
    return null;
  } else {
    return (
      <div>
        <BenchlingIcon icon="error" className="u-danger-color u-tiny-spacing-right" />
        {errorMessage}
        {errors && (
          <ul>
            {errors.map((error, i) => (
              <li key={i}>{error}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }
};

ErrorList.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string.isRequired),
  errorMessage: PropTypes.string,
};

export default ErrorList;
